/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Venueroomtitle2Inputs */

const en_venueroomtitle2 = /** @type {(inputs: Venueroomtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Room`)
};

const de_venueroomtitle2 = /** @type {(inputs: Venueroomtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Room`)
};

/**
* | output |
* | --- |
* | "Live Room" |
*
* @param {Venueroomtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const venueroomtitle2 = /** @type {((inputs?: Venueroomtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Venueroomtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_venueroomtitle2(inputs)
	return de_venueroomtitle2(inputs)
});
export { venueroomtitle2 as "venueRoomTitle" }